export const VOTE_CREATE_REQUEST = 'VOTE_CREATE_REQUEST';
export const VOTE_CREATE = 'VOTE_CREATE';
export const VOTE_FETCH_REQUEST = 'VOTE_FETCH_REQUEST';
export const VOTE_FETCH = 'VOTE_FETCH';
export const VOTE_UPDATE_REQUEST = 'VOTE_UPDATE_REQUEST';
export const VOTE_UPDATE = 'VOTE_UPDATE';
export const VOTE_DELETE_REQUEST = 'VOTE_DELETE_REQUEST';
export const VOTE_DELETE = 'VOTE_DELETE';
